<template>
  <div>
    <ul class="event">
      <TreeNode
        :node-data="nodedatacmp"
        @checkedchange="checkedchange"
      ></TreeNode>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TreeView',
  props: {
    treeData: Object
  },
  computed: {
    nodedatacmp: {
      get() {
        return this.setpath(this.treeData)
      },
      set(newValue) {
        this.$emit('change', newValue)
      }
    }
  },
  methods: {
    checkedchange(title, ischecked) {
      this.$emit('checkedchange', title, ischecked)
    },
    setpath(node, path) {
      var childpath = [node]
      if (path) {
        node.nodepath = path
        path.forEach(p => {
          childpath.push(p)
        })
      }
      if (node.children && node.children.length > 0) {
        node.children.forEach(res => {
          this.setpath(res, childpath)
        })
      }
      return node
    }
  }
}
</script>

<style scoped lang="scss">
li {
  list-style: none;
  cursor: pointer;
}
.event li > ul {
  padding-left: 20px;
  display: none;
}
input[type='checkbox'] {
  margin-right: 5px;
}
.push {
  transform: rotate(90deg);
}
</style>
